import { frontendURL } from 'dashboard/helper/URLHelper.js';
import store from 'dashboard/store';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import LiveChatCampaignsPage from './pages/LiveChatCampaignsPage.vue';
import SMSCampaignsPage from './pages/SMSCampaignsPage.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
import CampaignDetailPage from './pages/CampaignDetailPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            const accountId = Number(to.params.accountId);
            const isWhatsappCampaignEnabled = store.getters[
              'accounts/isFeatureEnabledonAccount'
            ](accountId, FEATURE_FLAGS.CAMPAIGNS);

            return {
              name: isWhatsappCampaignEnabled
                ? 'campaigns_whatsapp_index'
                : 'campaigns_ongoing_index',
              params: to.params,
            };
          },
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_livechat_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_sms_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          component: SMSCampaignsPage,
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
        {
          path: 'whatsapp/:campaignId',
          name: 'campaign_whatsapp_detail',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.CAMPAIGNS,
          },
          component: CampaignDetailPage,
          props: true,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
